import { z } from "zod";
export const zCorpWhoamiCompanyDto = z.object({
    id: z.string(),
    name: z.string(),
    status: z.string(),
});
export const zCorpWhoamiDto = z.object({
    adminId: z.string(),
    email: z.string(),
    fullName: z.string(),
    status: z.string(),
    companies: z.array(zCorpWhoamiCompanyDto),
});
